import common from '@/common'
import i18n from '@/lang'

export default {
    SET_LOGGED(state, payload) {
        state.isLogged = payload
        window.localStorage.setItem('isLogged', String(payload))
        if (!payload) {
            common.removeToken()
        }
    },
    SET_USER_INFO(state, payload) {
        state.userInfo = payload
        window.localStorage.setItem('userInfo', JSON.stringify(payload))
    },
    SET_USER_COMPANY_INFO(state, payload) {
        state.userCompanyInfo = {...state.userCompanyInfo, ...payload}
        this.commit('SET_LOCALE', state.userCompanyInfo.langCode)
        window.localStorage.setItem('userCompanyInfo', JSON.stringify(state.userCompanyInfo))
    },
    SET_IS_DISABLED(state, payload) {
        state.isDisabledAccount = payload
    },
    SET_ADMIN_SELECTED_COMPANY(state, payload) {
        state.adminSelectedCompany = {...state.adminSelectedCompany, ...payload}
        window.localStorage.setItem('adminSelectedCompany', JSON.stringify(state.adminSelectedCompany))
    },
    CLEAR_ADMIN_SELECTED_COMPANY(state) {
        state.adminSelectedCompany = {}
        window.localStorage.setItem('adminSelectedCompany', JSON.stringify(state.adminSelectedCompany))
    },
    SET_COLLAPSE_MENU(state, payload) {
        state.collapseMenu = payload
    },
    SET_CHAT_UNREAD(state, payload) {
        state.chatUnread = payload
    },
    SET_NOTICE_UNREAD(state, payload) {
        state.noticeUnread = payload
    },
    SET_COMPANY_ID(state, payload) {
        state.userCompanyInfo.id = payload
    },
    SET_IS_READ(state, payload) {
        state.noticeId = payload
    },
    SET_ALL_READ(state, payload) {
        state.noticeIdAll = payload
    },
    SET_HELPER_NOTIFICATION_UNREAD(state, payload) {
        state.helperNoticeUnread = payload
    },
    SET_CONTRACT_NOTIFICATION_UNREAD(state, payload) {
        state.contractNoticeUnread = payload
    },
    SET_HELPER_WITHDRAW_UNREAD(state, payload) {
        state.helperWithdrawUnread = payload
    },
    SET_SCHEDULE_LIST_LOCK(state, payload) {
        state.scheduleTaskEditLock = payload
        window.localStorage.setItem('scheduleLock', JSON.stringify(payload))
    },
    REMOVE_SCHEDULE_LOCK(state) {
        state.scheduleTaskEditLock = ''
        window.localStorage.removeItem('scheduleLock')
    },
    SET_IS_MOBILE_HIDE_MENU(state, payload) {
        state.isMobileHideMenu = payload
    },
    SET_LOCALE(state, payload) {
        const lang = payload === 'zh-HK' ? 'zh-Hant' : payload
        if (lang !== state.locale) {
            state.locale = lang
            i18n.locale = state.locale
            this.commit('dataMap/CHANGE_LANG')
        }
    },
    SET_SHOW_AGENCY_GUIDE(state, payload) {
        state.showAgencyGuide = payload
    },
    SET_COMPLETE_AGENCY_GUIDE(state, payload) {
        state.completeAgencyGuide = payload
    },
}
